export default "__VITE_ASSET__VZB2AIX3__"